import React from 'react';
import { FlatList, ScrollView } from 'react-native';
import { GridRefs } from '../../../../../v2BaseComponents/RichTable/types';
import { BulkAddClientRecord } from '../types';
import { useTableErrors } from './useTableErrors';
import { getIntl } from '../../../../../../utils/intl';
import Stack from '../../../../../v2BaseComponents/Stack';
import Text from '../../../../../v2BaseComponents/Text';
import Icon from '../../../../../v2BaseComponents/Icon';
import IconButton from '../../../../../v2BaseComponents/IconButton';

const intl = getIntl('profiles.bulkAddClientRecords.tableTopActions', {
    header: 'Review and Edit Client Records to Upload',
    noErrors: 'No Errors Found',
    error: 'Your File Contains {count} Error{plural}',
});

export type TableTopActionsOwnProps = {
    verticalFlatListRef: FlatList | null;
    horizontalScrollViewRef: ScrollView | null;
    gridInputRefs: GridRefs;
    records: BulkAddClientRecord[];
};

export type TableTopActionsProps = TableTopActionsOwnProps;

// not memoized because it relies on ref properties
export const TableTopActions: React.FC<TableTopActionsProps> = (props) => {
    const { tableErrorCount, onFocusNextError, isFocusNextErrorDisabled } = useTableErrors({
        records: props.records,
        verticalFlatListRef: props.verticalFlatListRef,
        horizontalScrollViewRef: props.horizontalScrollViewRef,
        gridInputRefs: props.gridInputRefs,
    });

    const renderSuccess = () => (
        <Stack horizontal space={4} align="center">
            <Icon name="CheckCircle" color="Success" size="button-icon" />
            <Text variant="body-1">{intl('noErrors')}</Text>
        </Stack>
    );

    const renderError = () => (
        <Stack horizontal space={4} align="center">
            <Icon name="AlertTriangle" color="Alert" size="button-icon" />
            <Text variant="body-1">
                {intl('error', { count: tableErrorCount, plural: tableErrorCount > 1 ? 's' : '' })}
            </Text>
            <IconButton
                icon="Search"
                onPress={onFocusNextError}
                isDisabled={isFocusNextErrorDisabled}
                variant="minimal"
                testID="focus-next-error-button"
            />
        </Stack>
    );

    return (
        <Stack
            horizontal
            fullWidth
            align="flex-end"
            justify="space-between"
            space={20}
            testID="table-actions-container"
        >
            <Text variant="bold-h4">{intl('header')}</Text>
            {tableErrorCount === 0 ? renderSuccess() : renderError()}
        </Stack>
    );
};
